import {EditOutlined} from '@mui/icons-material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import {IconButton, Menu, MenuItem, Typography} from '@mui/material'
import React, {useCallback, useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

const dataTestId = 'insight-detail-actions'

interface JtbdInsightActionsMenuProps {
  onEdit: () => void
}

export const JtbdInsightActionsMenu = ({onEdit}: JtbdInsightActionsMenuProps) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const [menuOpen, setMenuOpen] = useState(false)
  const menuButtonRef = useRef<HTMLButtonElement>(null)

  const openMenu = useCallback((e: React.MouseEvent) => {
    e.stopPropagation()
    setMenuOpen(true)
  }, [])

  const handleEdit = useCallback(() => {
    setMenuOpen(false)
    onEdit()
  }, [setMenuOpen, onEdit])

  return (
    <>
      <IconButton
        ref={menuButtonRef}
        onClick={openMenu}
        color="primary"
        data-test-id={dataTestId}
        size="small"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        data-test-id={`${dataTestId}-dropdown`}
        anchorEl={menuButtonRef.current}
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
      >
        <MenuItem onClick={handleEdit} data-test-id={`${dataTestId}-edit`}>
          <EditOutlined sx={{mr: 1}} fontSize="small" />
          <Typography variant="body2">{t('jobsToBeDone.action.edit')}</Typography>
        </MenuItem>
      </Menu>
    </>
  )
}
